<template>
  <div class="container">
    <div class="notification">
      <h2 class="subtitle">Competitors</h2>
    </div>

    <!-- v-if="!currentCard.locked"-->
    <div class="buttons is-left">
      <b-button type="is-info" icon-left="plus" v-on:click="addEmptyCompetitor">
        <span>Aggiungi competitor</span>
      </b-button>
    </div>

    <div v-if="competitors && currentCard.competitors.lenght != 0">
      <div
        v-for="(competitor, key) in currentCard.competitors"
        :key="`competitor_${competitor.id}_${key}`"
        class="notification"
        v-bind:class="{ 'is-warning': !competitor.id }"
      >
        <div class="columns">
          <div class="column">
            <b-field label="Brand">
              <b-input
                v-model="competitor.brand"
                placeholder="Nome del brand"
                requied
              ></b-input>
            </b-field>
          </div>

          <div class="column">
            <OpenSwitch
              label="Posizionamento"
              v-model="competitor.placement"
              required
            ></OpenSwitch>
          </div>
        </div>

        <div class="columns is-mobile">
          <div class="column">
            <b-field label="Gadget">
              <b-switch v-model="competitor.gadget"></b-switch>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Buoni sconto">
              <b-switch v-model="competitor.coupons"></b-switch>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Taglio prezzo">
              <b-switch v-model="competitor.priceCut"></b-switch
            ></b-field>
          </div>
          <div class="column">
            <b-field label="Assaggi">
              <b-switch v-model="competitor.tastings"></b-switch>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Hostess">
              <b-switch v-model="competitor.hostess"></b-switch>
            </b-field>
          </div>
        </div>

        <div class="buttons is-right">
          <b-button
            type="is-danger"
            icon-left="trash"
            v-on:click="removeCompetitor(competitor)"
            >Delete</b-button
          >
        </div>
      </div>
    </div>
    <!--<pre class="has-text-left">{{ currentCard }}</pre>-->
  </div>
</template>

<script>
import OpenSwitch from "../../../components/dropdown/OpenSwitch";

// value is array of competitors
const defaultCompetitor = () => ({
  id: 0,
  brand: "",
  placement: "",
  gadget: false,
  coupons: false,
  priceCut: false,
  hostess: false,
  tastings: false,
});

// v-on:input="$emit('input', $event.target.value)"
export default {
  name: "promoter.competitors",
  components: { OpenSwitch },
  props: {
    value: { required: true, type: Array },
    currentCard: { required: true },
  },
  data() {
    return {
      competitors: [],
    };
  },
  methods: {
    addEmptyCompetitor() {
      this.currentCard.competitors.push(defaultCompetitor());
      this.updateData(this.currentCard.competitors);
    },
    askRemoveCompetitor(entity) {
      this.$buefy.dialog.confirm({
        title: "Rimozione competitor",
        message: `Vuoi <b>rimuovere</b> l'elemento dalla lista?`,
        confirmText: "Rimuovi",
        cancelText: "Annulla",
        type: "is-warning",
        scroll: "keep",
        hasIcon: true,
        onConfirm: () => {
          let index = this.currentCard.competitors.indexOf(entity);
          this.$delete(this.currentCard.competitors, index);
        },
      });
    },
    removeCompetitor(entity) {
      if (!entity.id) {
        let index = this.currentCard.competitors.indexOf(entity);
        this.$delete(this.currentCard.competitors, index);
      } else {
        this.askRemoveCompetitor(entity);
      }
    },
    updateData(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>